// start:ng42.barrel
import './emailTemplates.service';
import './components';
// end:ng42.barrel

